const topMain = () => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;
    const sH = window.innerHeight;
    const secMain = document.querySelector('#jsSecMain');
    // const videoBox = secMain.querySelector('.js-video-box');
    const slideBox = secMain.querySelector('.js-slide-box');
    // const mainBox = secMain.querySelector('.js-main-box');


    // setTimeout(() => {
    //   mainBox.classList.add('act')
    // }, 1000);


    let y
    if (sW > 750) {
      y = sH * 0.5
    } else {
      y = sH * 0.0
    }


    let to1 = gsap.to(slideBox, {
      y: y,
      ease: "none",
      scrollTrigger: {
        trigger: secMain,
        start: 'bottom bottom',
        end: 'bottom top',
        scrub: 0,
        // markers: true
      }
    })

    // let to2 = gsap.to(mainBox, {
    //   y: sH * 0.3,
    //   ease: "none",
    //   scrollTrigger: {
    //     trigger: secMain,
    //     start: 'bottom bottom',
    //     end: 'bottom top',
    //     scrub: 0,
    //     // markers: true
    //   }
    // })


    let target = document.querySelector('body');
    let observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        to1.scrollTrigger.refresh()
        // to2.scrollTrigger.refresh()
        // console.log('comParallax refresh');
      });
    });
    observer.observe(target);





  }
}
export default topMain;